<template>
  <div class="user-profile-drop-down-content">
    <div class="card">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="avatar-profile mr-3">
            <img
              :src="require('@/assets/images/avatar-placeholder.png')"
              alt="User picture"
            />
            <div class="badge">
              <img
                :src="require('@/assets/images/blitzpay-badge.png')"
                alt="Badge"
              />
            </div>
          </div>
          <div class="d-flex flex-column text-truncate ml-2">
            <span class="text-truncate fs-14">
              {{ info.name }}
            </span>
            <div class="text-secondary fs-12 text-truncate">
              {{ info.email }}
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>

    <!-- <b-dropdown-item>
      <router-link
        class="btn btn-block btn-outline-primary flat-button mb-3"
        :to="{ name: 'user-profile' }"
        @click.capture="$emit('close')"
      >
        Editar perfil
      </router-link>
    </b-dropdown-item> -->

    <b-dropdown-item>
      <router-link
        class="btn btn-item justify-content-start"
        :to="{ name: 'user-personal-data' }"
        @click.capture="$emit('close')"
      >
        <i class="fa-solid fa-user mr-3" />
        <span>Dados Pessoais</span>
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item>
      <router-link
        class="btn btn-item justify-content-start"
        :to="{ name: 'user-financial-data' }"
        @click.capture="$emit('close')"
      >
        <i class="fa-solid fa-wallet" />
        <span>Dados Financeiros</span>
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item v-if="info.refer_url">
      <button class="btn btn-item justify-content-start" @click="copyLink">
        <i class="fa-solid fa-copy mr-3" />
        <span>Copiar Link (Indique & Ganhe)</span>
      </button>
    </b-dropdown-item>
    <!-- <b-dropdown-item>
      <router-link
        class="btn btn-item justify-content-start"
        :to="{ name: 'achievements' }"
        @click.capture="$emit('close')"
      >
        <i class="icon-trophy mr-3" />
        <strong>Conquistas</strong>
      </router-link>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item>
      <router-link
        class="btn btn-item justify-content-start"
        :to="{ name: 'user-preferences' }"
        @click.capture="$emit('close')"
      >
        <i class="icon-settings mr-3" />
        <strong>Preferências</strong>
      </router-link>
    </b-dropdown-item> -->
    <!-- <router-link
      class="btn btn-item justify-content-start"
      :to="{ name: 'user-personal-data' }"
      disabled
    >
      <i class="icon-user mr-3" />
      <strong>Informações Pessoais</strong>
    </router-link> -->
    <b-dropdown-item class="pt-6">
      <button
        class="btn btn-item justify-content-start"
        @click="$emit('logout')"
      >
        <i class="fa-solid fa-power-off mr-3" />
        <span>Sair</span>
      </button>
    </b-dropdown-item>
  </div>
</template>

<script>
export default {
  computed: {
    info() {
      if (!this.$user.user) return { name: "", email: "" };

      return this.$user.user;
    }
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.info.refer_url);
    }
  }
};
</script>

<style lang="scss" scoped>
.user-profile-drop-down-content {
  padding: 12px 24px;

  .flat-button {
    min-height: 28px;
    max-height: 28px;
  }

  .avatar-profile {
    border: 1px solid #9155ec;
    border-radius: 50%;
    position: relative;

    img {
      width: 50px;
      height: 50px;
      object-fit: cover;
      border-radius: 50%;
      margin: 2px;
    }

    .badge {
      position: absolute;
      right: -20%;
      bottom: -10%;

      img {
        width: 24px;
        height: 24px;
        object-fit: cover;
        border-radius: 50%;
      }
    }
  }

  i {
    font-size: 16px;
    color: rgba(59, 59, 74, 0.9);
  }

  span {
    font-weight: 500;
    font-size: 14px;
    color: rgba(59, 59, 74, 0.9);
  }

  .fa-wallet {
    margin-right: 6px;
  }

  small {
    word-break: break-word;
    font-weight: 400;
  }

  hr {
    margin: 1px 0;
    background-color: rgba(208, 209, 221, 0.85);
    opacity: 0.2;
  }

  .btn-item {
    min-height: 32px;
    max-height: 32px;
    padding: 0;
    font-size: 13px;
    width: 100%;
  }
  ::v-deep li {
    list-style: none;
  }
  ::v-deep.dropdown-item {
    padding: 0;
    &:hover {
      background: transparent;
    }
    &:active {
      background: rgba(0, 0, 0, 0.1);
    }
  }

  .card {
    margin: -12px;
    margin-bottom: 12px;
    border-radius: 0px;
    border: none;
    overflow: hidden;

    .card-body {
      padding: 12px;
    }
  }
}
</style>
